"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __values = (this && this.__values) || function(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var classnames_1 = __importDefault(require("classnames"));
var lodash_1 = require("lodash");
var mobx_react_1 = require("mobx-react");
var react_1 = __importDefault(require("react"));
var FlattenJson_1 = __importDefault(require("@CommonFrontendBackend/FlattenJson/FlattenJson"));
var ImportFromSource = (function (_super) {
    __extends(ImportFromSource, _super);
    function ImportFromSource() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.renderPreviewVariables = function () {
            return (react_1.default.createElement("div", null,
                react_1.default.createElement("header", { className: "step-header" },
                    react_1.default.createElement("span", { className: "icon icon-eye" }),
                    react_1.default.createElement("div", { className: "text-content" },
                        react_1.default.createElement("h3", { className: "title" }, "Preview variables from data"),
                        react_1.default.createElement("p", { className: "subtitle" }, "Preview the available variables to be used in your document from the imported data."))),
                react_1.default.createElement("div", { className: "preview-table-container" },
                    react_1.default.createElement("table", null,
                        react_1.default.createElement("tbody", null,
                            react_1.default.createElement("tr", null,
                                react_1.default.createElement("th", null, "Variable Name"),
                                react_1.default.createElement("th", null, "Example Values")),
                            _this.flattenVariables().map(_this.renderPreviewVariableRow))))));
        };
        _this.renderPreviewVariableRow = function (variable) {
            return (react_1.default.createElement("tr", { key: variable.key },
                react_1.default.createElement("td", null, variable.key),
                react_1.default.createElement("td", null, variable.value)));
        };
        _this.flattenVariables = function () {
            var e_1, _a;
            var flattenedVariables = [];
            if (!_this.props.variables) {
                return flattenedVariables;
            }
            var sample = (0, FlattenJson_1.default)((0, lodash_1.cloneDeep)(_this.props.variables), undefined, function (parentProp, childProp) {
                return "".concat(parentProp, ".").concat(childProp);
            });
            var keys = Object.keys(sample);
            try {
                for (var keys_1 = __values(keys), keys_1_1 = keys_1.next(); !keys_1_1.done; keys_1_1 = keys_1.next()) {
                    var key = keys_1_1.value;
                    if (key.match(/^\_/)) {
                        continue;
                    }
                    flattenedVariables.push({
                        key: key,
                        value: _this.props.variables[key],
                    });
                }
            }
            catch (e_1_1) { e_1 = { error: e_1_1 }; }
            finally {
                try {
                    if (keys_1_1 && !keys_1_1.done && (_a = keys_1.return)) _a.call(keys_1);
                }
                finally { if (e_1) throw e_1.error; }
            }
            return flattenedVariables;
        };
        return _this;
    }
    ImportFromSource.prototype.render = function () {
        var _a = this.props, goBackToThisStep = _a.goBackToThisStep, finished = _a.finished, importError = _a.importError;
        return (react_1.default.createElement("section", { className: (0, classnames_1.default)(["step", "import-data", { finished: finished }]) },
            react_1.default.createElement("div", { className: "connector-line" }),
            finished && react_1.default.createElement("div", { className: "step-finished-badge icon-check" }),
            react_1.default.createElement("header", { className: "step-header" },
                react_1.default.createElement("div", { className: "icon-save icon" }),
                react_1.default.createElement("div", { className: "text-content" },
                    react_1.default.createElement("h3", { className: "title" },
                        react_1.default.createElement("span", { className: "step-number" }, "2."),
                        "Import Data"),
                    react_1.default.createElement("p", { className: "subtitle" }, "Import your data from the selected source."),
                    importError && react_1.default.createElement("p", { className: "error-message" }, importError))),
            react_1.default.createElement("div", { className: "import-sources" }, this.props.children),
            finished && (react_1.default.createElement("section", { className: (0, classnames_1.default)(["step", "preview-variables", { finished: finished }]) },
                react_1.default.createElement("div", { className: "connector-line" }),
                this.renderPreviewVariables())),
            finished && (react_1.default.createElement("div", { className: "back-step-hover-tile", onClick: goBackToThisStep },
                react_1.default.createElement("label", { className: "label" }, "Go Back")))));
    };
    ImportFromSource = __decorate([
        mobx_react_1.observer
    ], ImportFromSource);
    return ImportFromSource;
}(react_1.default.Component));
exports.default = ImportFromSource;
